// Drizzle `mode: 'timestamp_ms'` columns are JS Date objects on the server
// and JSON-serialize as ISO strings. The frontend *Row types declare
// `number` but receive a string at runtime. This helper normalizes both
// shapes to a millisecond epoch so consumers can compare/sort/filter
// without ad-hoc parsing scattered through the codebase.
export function toMs(value: number | string | Date | null | undefined): number {
  if (value == null) return NaN;
  if (typeof value === 'number') return value;
  if (value instanceof Date) return value.getTime();
  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : NaN;
}
